<div class="nfs-block">
	<ng-container *ngIf="(recentCount$ | async) > 0">
		<app-notification *ngFor="let notification of (this.recentNotifications$ | async)"
			[userNfs]="notification" [notificationOP]="notificationOP"></app-notification>
	</ng-container>
</div>

<div class="nf-footer">
    <div class="nf-other" [routerLink]="['/notifications']" (click)="openNFPage()">
        <span *ngIf="(otherUnreadCount$ | async) > 0">
            +{{otherUnreadCount$ | async}} other unread notifications
        </span>
        <span *ngIf="(otherUnreadCount$ | async) <= 0">
            View all notifications
        </span>
	</div>
</div>